const AllEmployees = () => import("../employee/views/AllEmployees.vue");
const EmployeeForm = () => import("../employee/views/EmployeeForm.vue");
const EmployeeSettings = () => import("../employee/views/EmployeeSettings.vue");
const EmployeeDesignation = () =>
  import("../employee/views/EmployeeDesignation.vue");
const EmployeeTypes = () => import("../employee/views/EmployeeTypes.vue");
const EmployeeGrades = () => import("../employee/views/EmployeeGrades.vue");
const EmployeeCategories = () =>
  import("../employee/views/EmployeeCategories.vue");
const EmployeeDetailsView = () =>
  import("../employee/components/EmployeeDetailsView.vue");
const SendInviteForm = () => import("../employee/views/SendInviteForm.vue");
const EmployeeArchive = () => import("../employee/views/EmployeeArchive.vue");
export default [
  {
    path: "view-all",
    component: AllEmployees,
  },
  {
    path: "send-invite",
    component: SendInviteForm,
  },
  {
    path: "view/:id",
    name: "employee-profile",
    component: EmployeeDetailsView,
  },
  {
    path: "edit/:id",
    component: EmployeeForm,
  },
  {
    path: "create",
    component: EmployeeForm,
  },
  {
    path: "settings",
    component: EmployeeSettings,
  },
  {
    path: "settings/designation",
    component: EmployeeDesignation,
  },
  {
    path: "settings/grades",
    component: EmployeeGrades,
  },
  {
    path: "settings/categories",
    component: EmployeeCategories,
  },
  {
    path: "settings/types",
    component: EmployeeTypes,
  },
  {
    path: "archive",
    component: EmployeeArchive,
  },
];
